import { render, staticRenderFns } from "./KennaSecurity.vue?vue&type=template&id=c96e9404&"
import script from "./KennaSecurity.vue?vue&type=script&lang=js&"
export * from "./KennaSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c96e9404')) {
      api.createRecord('c96e9404', component.options)
    } else {
      api.reload('c96e9404', component.options)
    }
    module.hot.accept("./KennaSecurity.vue?vue&type=template&id=c96e9404&", function () {
      api.rerender('c96e9404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/integrations/KennaSecurity.vue"
export default component.exports